/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { UsersService } from './services/users.service';
import { TendersService } from './services/tenders.service';
import { StockingService } from './services/stocking.service';
import { ProductSortimentsService } from './services/product-sortiments.service';
import { PurchaseListsService } from './services/purchase-lists.service';
import { ProductsService } from './services/products.service';
import { ProductTransfersService } from './services/product-transfers.service';
import { PricingService } from './services/pricing.service';
import { PackagesService } from './services/packages.service';
import { OrderListsService } from './services/order-lists.service';
import { OffersService } from './services/offers.service';
import { MerchantsService } from './services/merchants.service';
import { MeService } from './services/me.service';
import { ImportService } from './services/import.service';
import { ImagesService } from './services/images.service';
import { StoredFiltersService } from './services/stored-filters.service';
import { DiscountsService } from './services/discounts.service';
import { VipDiscountsService } from './services/vip-discounts.service';
import { DeliveryMethodsService } from './services/delivery-methods.service';
import { ContainersService } from './services/containers.service';
import { ContainerSortimentsService } from './services/container-sortiments.service';
import { ProductSearchService } from './services/product-search.service';
import { ContractsService } from './services/contracts.service';
import { AuthNAndAuthZService } from './services/auth-n-and-auth-z.service';
import { VersionService } from './services/version.service';
import { RegistrationStatementService } from './services/registration-statement.service';
import { PackageSortimentsService } from './services/package-sortiments.service';
import { ReportsService } from './services/reports.service';
import { PurchaseService } from './services/purchase.service';
import { PublicEndpointsService } from './services/public-endpoints.service';
import { DeliveryMethodsAdminService } from './services/delivery-methods-admin.service';
import { DictionaryService } from './services/dictionary.service';
import { RootService } from './services/root.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    UsersService,
    TendersService,
    StockingService,
    ProductSortimentsService,
    PurchaseListsService,
    ProductsService,
    ProductTransfersService,
    PricingService,
    PackagesService,
    OrderListsService,
    OffersService,
    MerchantsService,
    MeService,
    ImportService,
    ImagesService,
    StoredFiltersService,
    DiscountsService,
    VipDiscountsService,
    DeliveryMethodsService,
    ContainersService,
    ContainerSortimentsService,
    ProductSearchService,
    ContractsService,
    AuthNAndAuthZService,
    VersionService,
    RegistrationStatementService,
    PackageSortimentsService,
    ReportsService,
    PurchaseService,
    PublicEndpointsService,
    DeliveryMethodsAdminService,
    DictionaryService,
    RootService,
    ApiConfiguration
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
